import React, { useEffect, useState } from 'react';
import { Input, Radio, RadioChangeEvent, Tag } from 'antd';
import { productUnit, initProductUnit } from '../../../model/master';

const { TextArea } = Input;

interface props {
    productUnit: productUnit,
    disabled?: boolean,
    onChange: (data: any) => void
}

const commonUnits = [
    { name: 'ชิ้น', symbol: 'pcs' },
    { name: 'แพ็ค', symbol: 'pk' },
    { name: 'ลัง', symbol: 'box' },
    { name: 'ถุง', symbol: 'bag' },
    { name: 'กล่อง', symbol: 'box' },
    { name: 'ขวด', symbol: 'btl' },
    { name: 'กระป๋อง', symbol: 'can' },
    { name: 'กิโลกรัม', symbol: 'kg' },
    { name: 'กรัม', symbol: 'g' },
    { name: 'ลิตร', symbol: 'L' },
    { name: 'มัด', symbol: 'bnd' },
    { name: 'โหล', symbol: 'dz' },
];

const ProductUnitDetail: React.FC<props> = (prop) => {
    const [data, setData] = useState<productUnit>(initProductUnit);

    const onDataChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        let key: string = String(e.target.name);
        let value: any = e.target.value;
        let object: any = { ...data, [key]: value };
        setData(object);
        prop.onChange(object);
    };

    const onStatusChange = (e: RadioChangeEvent) => {
        let object: any = { ...data, status: e.target.value };
        setData(object);
        prop.onChange(object);
    };

    const onSelectQuickUnit = (unit: { name: string, symbol: string }) => {
        if (prop.disabled) return;
        let object: any = { ...data, name: unit.name, symbol: unit.symbol };
        setData(object);
        prop.onChange(object);
    };

    useEffect(() => {
        setData(prop.productUnit || initProductUnit);
    }, [prop.productUnit]);

    return (
        <div className='detailFormContainer'>
            {!prop.disabled && (
                <div className='formRow'>
                    <div className='formGroup'>
                        <label className='formLabel'>💡 หน่วยมาตรฐานยอดนิยม (คลิกเลือกทันที)</label>
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '6px'}}>
                            {commonUnits.map((u, i) => (
                                <Tag 
                                    key={i} 
                                    style={{
                                        cursor: 'pointer',
                                        padding: '5px 12px',
                                        borderRadius: '10px',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        background: data.name === u.name ? 'var(--primary, #FF7A59)' : 'var(--bg-subtle, #F1F5F9)',
                                        color: data.name === u.name ? '#FFFFFF' : 'var(--text-primary, #334155)',
                                        border: `1px solid ${data.name === u.name ? 'var(--primary, #FF7A59)' : 'var(--border-subtle, #E2E8F0)'}`,
                                        transition: 'all 0.2s ease'
                                    }}
                                    onClick={() => onSelectQuickUnit(u)}
                                >
                                    {u.name} ({u.symbol})
                                </Tag>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            <div className='formRow' style={{marginTop: '8px'}}>
                <div className='formGroup'>
                    <label className='formLabel required'>ชื่อหน่วยสินค้า</label>
                    <Input 
                        name="name" 
                        placeholder="เช่น ชิ้น, แพ็ค, กิโลกรัม, ขวด" 
                        value={data.name} 
                        onChange={onDataChange} 
                        disabled={prop.disabled} 
                    />
                </div>
            </div>

            <div className='formRow'>
                <div className='formGroup'>
                    <label className='formLabel'>สัญลักษณ์ / ตัวย่อ</label>
                    <Input 
                        name="symbol" 
                        placeholder="เช่น pcs, pk, kg, btl" 
                        value={data.symbol} 
                        onChange={onDataChange} 
                        disabled={prop.disabled} 
                    />
                </div>
            </div>

            <div className='formRow'>
                <div className='formGroup'>
                    <label className='formLabel'>คำอธิบาย / หมายเหตุ</label>
                    <TextArea 
                        name="remark" 
                        rows={3} 
                        placeholder="ระบุรายละเอียดเพิ่มเติม..." 
                        value={data.remark} 
                        onChange={onDataChange} 
                        disabled={prop.disabled} 
                    />
                </div>
            </div>

            <div className='formRow'>
                <div className='formGroup'>
                    <label className='formLabel'>สถานะการใช้งาน</label>
                    <Radio.Group 
                        onChange={onStatusChange} 
                        value={data.status !== undefined ? data.status : 1}
                        disabled={prop.disabled}
                    >
                        <Radio value={1}>🟢 ใช้งานปกติ (Active)</Radio>
                        <Radio value={0}>⚪ ปิดการใช้งาน (Inactive)</Radio>
                    </Radio.Group>
                </div>
            </div>
        </div>
    );
};

export default ProductUnitDetail;
